<template>
  <div class="com-box">
    <div class="card">
      <img class="left" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EA/rB8LrmUvgCmAKWQZAAECFkWWr5w518.png" alt="" />
      <div class="right">
        <div class="title-1">暂无门店名称</div>
        <div class="title-2">暂无门店地址</div>
        <div class="bottom">
          <img class="icon" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EA/rB8LrmUvgSaAJVDcAAAEPbvLynI460.png" alt="" />
          <div class="btn">打电话</div>
        </div>
      </div>
    </div>
    <img class="more" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/A1/rB8LrmU3q0eAYPY_AAAXpRxXwfQ444.png" alt="">
  </div>
</template>

<script>
export default {}
</script>

<style lang="stylus" scoped>
  .com-box {
    overflow: hidden;
    width: 100%;
    height: 277px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/58/rB8LrmU_Ex2ALdXMAADXud6Q-yk830.png');
    background-size: 100% 100%;
    .card {
      display: flex;
      width: 307px;
      height: 142px;
      border-radius: 5px;
      margin: auto;
      margin-top: 76px
      padding: 13px;
      box-sizing: border-box;
      background: linear-gradient(0deg, #FFF3DF, #FFFCF6);
      .left {
        width: 85px;
        height: 116px;
      }
      .right {
        width: 207px;
        margin-left: 13px;
        margin-top: 4px;
        .title-1 {
          color: #E24409;
          font-size: 15px;
          font-weight: bold;
        }
        .title-2 {
          color: #BC481C;
          font-size: 14px;
          margin-top: 12px;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 14px;
          .icon {
            width: 80px;
            height: 14px;
          }
          .btn {
            width: 78px;
            height: 43px
            color: #fff;
            font-size: 14px;
            text-align: center;
            line-height: 36px;
            background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EB/rB8LrmUvg1uAWRORAAAfnOsZFXo353.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .more {
      display: block
      width: 111px;
      height: 36px
      margin: auto;
      margin-top: 8px;
    }
  }
</style>